import { render, staticRenderFns } from "./MomoRedeemRecord.vue?vue&type=template&id=00fb52dc&"
import script from "./MomoRedeemRecord.vue?vue&type=script&lang=js&"
export * from "./MomoRedeemRecord.vue?vue&type=script&lang=js&"
import style0 from "./MomoRedeemRecord.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports